import { Colors } from '../../theme'
import RadioButtonStyles from '../../styles/components/radio-buttons'

export default {
  ...RadioButtonStyles,
  dentalRadioButton: {
    float: 'left'
  },
  dentalRadioButtonGroup: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    '& label:not(:last-child)': {
      marginRight: 50
    }
  },
  radioColumn: {
    padding: 20
  },
  expensesCovered: {
    padding: 20,
    borderLeft: `1px solid ${Colors.Palette.borderColor}`,
    width: 400
  },
  expensesCoveredTitle: {
    marginTop: 0,
    opacity: '0.8'
  },
  ul: {
    padding: '5px 20px'
  },
  li: {
    margin: 2,
    fontSize: '0.875rem'
  },
  loadingContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '10%'
  },
  serviceNote: {
    maxWidth: 450,
    textTransform: 'lowercase',
    fontSize: '0.77rem'
  },
  embeddedLinkStyles: {
    color: Colors.Palette.primaryColor,
    fontSize: '0.77rem',
    textDecoration: 'underline',
    fontWeight: 400
  },
  button: {
    alignSelf: 'right'
  },
  dentalTitle: {
    width: '100%'
  },
  emptyStateContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20
  },
  emptyStateIcon: {
    fontSize: 120,
    color: '#d0d0d0'
  }
}



// WEBPACK FOOTER //
// ./src/controls/claimTypeButton/styles.js